export { default } from "./UpsertRole";



// WEBPACK FOOTER //
// ./src/mutations/UpsertRole/index.ts